exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "calendar-inline-paginator header{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;height:50px;border:1px solid #eaebed}calendar-inline-paginator header .subtitle{position:absolute;top:13px;left:24px;height:16px;font-family:Stag Sans;font-size:16px;font-weight:300;text-align:center;color:#666}calendar-inline-paginator header h1{margin:0;position:relative;display:block;top:13px;height:14px;font-family:Stag Sans;font-weight:400;text-transform:capitalize;font-size:14px;text-align:center;color:#0072c9}calendar-inline-paginator header h1 a{padding-left:5px;padding-right:5px;font-size:20px;line-height:20px;vertical-align:middle}calendar-inline-paginator header h1 a:focus,calendar-inline-paginator header h1 a:hover{text-decoration:none;background-color:inherit}calendar-inline-paginator header h1 .title{display:inline-block;width:110px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlinePaginator/calendarInlinePaginator.scss
// module id = 1490
// module chunks = 0